<template>
  <div
    v-click-outside="clickOutside"
    class="date-picker-modal"
    :class="[
      {'date-picker-modal_position': position},
      {'date-picker-modal_left': left}
    ]"
    @click.stop="mobileStatus ? clickOutside() : false"
  >
    <DatePicker
      v-if="yearSettings"
      v-model="selectedDate"
      :modelConfig="modelConfig"
      :timezone="timezone"
      :mode="isRange ? 'range' : 'single'"
      :masks="{title: 'MMMM YYYY'}"
      :locale="language"
      isInline
      @input="changeDateInput($event)"
    >
      <i
        slot="header-left-button"
        slot-scope="page"
        class="ub-icon-arrow date-picker-modal__icon_prev"
        @click="page.movePrevMonth()"
      >
      </i>
      <i
        slot="header-right-button"
        slot-scope="page"
        class="ub-icon-arrow date-picker-modal__icon_next"
        @click="page.moveNextMonth()"
      >
      </i>
    </DatePicker>
    <DatePicker
      v-else
      v-model="selectedDate"
      :modelConfig="modelConfig"
      :timezone="timezone"
      :masks="{title: 'MMMM YYYY'}"
      :mode="isRange ? 'range' : 'single'"
      :minDate="new Date()"
      :locale="language"
      isInline
      @input="changeDateInput($event)"
    >
      <i
        slot="header-left-button"
        slot-scope="page"
        class="ub-icon-arrow date-picker-modal__icon_prev"
        @click="page.movePrevMonth()"
      >
      </i>
      <i
        slot="header-right-button"
        slot-scope="page"
        class="ub-icon-arrow date-picker-modal__icon_next"
        @click="page.moveNextMonth()"
      >
      </i>
    </DatePicker>
  </div>
</template>

<script>

import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import ClickOutside from 'vue-click-outside';
import MobileDetect from 'mobile-detect';

export default {
  name: 'DatePickerModal',
  components: {
    DatePicker,
  },
  directives: {
    ClickOutside,
  },
  props: {
    date: {
      type: [Date, String, Object],
      default: new Date(),
    },
    modelConfig: {
      type: Object,
      default: () => {},
    },
    timezone: {
      type: String,
      default: 'utc',
    },
    position: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    isRange: {
      type: Boolean,
      default: false,
    },
    datePicker: {
      type: Boolean,
      default: false,
    },
    yearSettings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      interval: '',
    };
  },
  computed: {
    mobileStatus() {
      const md = new MobileDetect(window.navigator.userAgent);
      const mobile = md.mobile();
      const tablet = md.tablet();
      return mobile !== null || tablet !== null;
    },
    selectedDate: {
      get() {
        if (this.isRange) {
          const { start: startDate, end: endDate } = this.date;
          const start = new Date(startDate);
          const end = new Date(endDate);
          const date = {
            ...this.date,
            start,
            end,
          };
          return date;
        }
        return new Date(this.date);
      },
      set(data) {
        if (this.isRange) {
          const { start, end } = data;
          const rangeDate = {
            ...this.date,
            start,
            end,
          };
          this.$emit('update:date', rangeDate);
        } else {
          this.$emit('update:date', data);
        }
      },
    },
    language() {
      return this.$i18n.locale;
    },
  },
  methods: {
    clickOutside() {
      this.$emit('update:datePicker', false);
    },
    changeDateInput(e) {
      this.$emit('changeClickedFromDatePicker');
      const { start, end } = e;
      if (start !== undefined || end !== undefined) {
        const date = {
          start,
          end,
        };
        this.$emit('changeFilterQuery', date);
      }
      this.clickOutside();
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";

.date-picker-modal {
  position: absolute;
  right: 0;
  width: 328px;
  height: 306px;
  background: $color-white;
  left: 372px;
  top: 20px;
  z-index: 111;

  &_position {
    z-index: 10;
    top: 40px;
  }

  &_left {
    left: 0;
    right: auto;
    top: 42px;
  }

  .vc-container {
    @include tablet-portrait {
      width: 328px;
      height: 339px;
      min-height: auto;
      min-width: auto;
      z-index: 111;
      position: relative;
    }

    @include mobile-small {
      width: 280px;
    }
  }

  @include tablet-portrait {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba($color-black, .5);
  }

  &__icon {
    transition: color .15s ease-in;

    &:hover {
      color: $color-dodger-blue;
    }

    &_prev {
      transform: rotate(90deg);
      top: 9px;
      position: absolute;
      right: 33px;
      font-size: $font-size-xlg;
    }

    &_next {
      transform: rotate(-90deg);
      top: 9px;
      position: absolute;
      right: 1px;
      font-size: $font-size-xlg;
    }
  }
}

</style>
